/* eslint no-invalid-this: 0 */
import { createCustomError } from "../utils/createCustomError";
const errors = {
    additionalItemsError: createCustomError("AdditionalItemsError"),
    additionalPropertiesError: createCustomError("AdditionalPropertiesError"),
    allOfError: createCustomError("AllOfError"),
    anyOfError: createCustomError("AnyOfError"),
    constError: createCustomError("ConstError"),
    containsAnyError: createCustomError("ContainsAnyError"),
    containsArrayError: createCustomError("ContainsArrayError"),
    containsError: createCustomError("ContainsError"),
    containsMaxError: createCustomError("ContainsMaxError"),
    containsMinError: createCustomError("ContainsMinError"),
    enumError: createCustomError("EnumError"),
    forbiddenPropertyError: createCustomError("ForbiddenPropertyError"),
    formatDateError: createCustomError("FormatDateError"),
    formatDateTimeError: createCustomError("FormatDateTimeError"),
    formatDurationError: createCustomError("FormatDurationError"),
    formatEmailError: createCustomError("FormatEmailError"),
    formatHostnameError: createCustomError("FormatHostnameError"),
    formatIPV4Error: createCustomError("FormatIPV4Error"),
    formatIPV4LeadingZeroError: createCustomError("FormatIPV4LeadingZeroError"),
    formatIPV6Error: createCustomError("FormatIPV6Error"),
    formatIPV6LeadingZeroError: createCustomError("FormatIPV6LeadingZeroError"),
    formatJsonPointerError: createCustomError("FormatJsonPointerError"),
    formatRegExError: createCustomError("FormatRegExError"),
    formatTimeError: createCustomError("FormatTimeError"),
    formatURIError: createCustomError("FormatURIError"),
    formatURIReferenceError: createCustomError("FormatURIReferenceError"),
    formatURITemplateError: createCustomError("FormatURITemplateError"),
    formatURLError: createCustomError("FormatURLError"),
    formatUUIDError: createCustomError("FormatUUIDError"),
    invalidDataError: createCustomError("InvalidDataError"),
    invalidPropertyNameError: createCustomError("InvalidPropertyNameError"),
    invalidSchemaError: createCustomError("InvalidSchemaError"),
    invalidTypeError: createCustomError("InvalidTypeError"),
    maximumError: createCustomError("MaximumError"),
    maxItemsError: createCustomError("MaxItemsError"),
    maxLengthError: createCustomError("MaxLengthError"),
    maxPropertiesError: createCustomError("MaxPropertiesError"),
    minimumError: createCustomError("MinimumError"),
    minItemsError: createCustomError("MinItemsError"),
    minItemsOneError: createCustomError("MinItemsOneError"),
    minLengthError: createCustomError("MinLengthError"),
    minLengthOneError: createCustomError("MinLengthOneError"),
    minPropertiesError: createCustomError("MinPropertiesError"),
    missingDependencyError: createCustomError("MissingDependencyError"),
    missingOneOfPropertyError: createCustomError("MissingOneOfPropertyError"),
    multipleOfError: createCustomError("MultipleOfError"),
    multipleOneOfError: createCustomError("MultipleOneOfError"),
    noAdditionalPropertiesError: createCustomError("NoAdditionalPropertiesError"),
    notError: createCustomError("NotError"),
    oneOfError: createCustomError("OneOfError"),
    oneOfPropertyError: createCustomError("OneOfPropertyError"),
    patternError: createCustomError("PatternError"),
    patternPropertiesError: createCustomError("PatternPropertiesError"),
    requiredPropertyError: createCustomError("RequiredPropertyError"),
    schemaWarning: createCustomError("SchemaWarning"),
    typeError: createCustomError("TypeError"),
    undefinedValueError: createCustomError("UndefinedValueError"),
    unevaluatedItemsError: createCustomError("UnevaluatedItemsError"),
    unevaluatedPropertyError: createCustomError("UnevaluatedPropertyError"),
    uniqueItemsError: createCustomError("UniqueItemsError"),
    unknownPropertyError: createCustomError("UnknownPropertyError"),
    valueNotEmptyError: createCustomError("ValueNotEmptyError")
};
export default errors;
